import React from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { ServiceHero } from '../components/ServiceHero';
import { ServiceContactForm } from '../components/ServiceContactForm';
import { CheckCircleIcon } from 'lucide-react';
export function PersonalCareServices() {
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-1137">
      <Navbar data-id="element-1138" />
      <main className="flex-1" data-id="element-1139">
        <ServiceHero badge="Care Solutions" title="Personal Care Services" subtitle="Compassionate daily living support from vetted PSWs — all with clinical oversight." imageUrl="https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=1600&auto=format&fit=crop" data-id="element-1140" />

        <div className="max-w-4xl mx-auto px-4 py-16 lg:py-24" data-id="element-1141">
          <div className="prose prose-lg max-w-none text-text-muted leading-relaxed space-y-6" data-id="element-1142">
            <p data-id="element-1143">
              Our Personal Care Services provide compassionate daily living
              support from vetted Personal Support Workers (PSWs). We assist
              with bathing, grooming, mobility, meal preparation, and
              companionship, ensuring individuals receive the care they need to
              maintain their independence and quality of life.
            </p>
            <p data-id="element-1144">
              Every care plan is nurse-supervised, ensuring the highest
              standards of clinical quality and patient safety. Our caregivers
              are trained to provide personalized care that meets the unique
              needs of each individual, promoting dignity, respect, and
              well-being.
            </p>
          </div>

          <div className="mt-12 bg-gray-50 rounded-2xl p-8 border border-gray-100" data-id="element-1145">
            <h3 className="text-2xl font-bold text-text-dark mb-6" data-id="element-1146">
              Comprehensive Personal Care
            </h3>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1147">
              {['Bathing, grooming & personal hygiene', 'Mobility assistance & fall prevention', 'Nutritious meal preparation & dietary support', 'Light housekeeping & organization', 'Medication reminders & scheduling', 'Nurse-supervised care plans'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-1148">
                  <CheckCircleIcon className="w-6 h-6 text-accent-teal flex-shrink-0 mt-0.5" data-id="element-1149" />
                  <span className="text-text-dark font-medium" data-id="element-1150">{feature}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <ServiceContactForm serviceName="Personal Care Services" data-id="element-1151" />
      </main>
      <StickyFooter data-id="element-1152" />
    </div>;
}